<div class="author-page author vcard inline-items more">
    <button (click)="toggleTheme()" style="position: fixed; top:69px; right:0px; z-index: 999; background-color: #000000; color: white;">
        <i class="fad fa-moon" style="width: 30px; font-size: 30px; color: white;"></i>
    </button>
</div>